import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { APP_NAME, ROUTES } from '@utils/constants';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Legal',
      links: [
        { name: 'Terms of Service', href: ROUTES.TERMS_OF_SERVICE },
        { name: 'Privacy Policy', href: ROUTES.PRIVACY_POLICY },
        { name: 'Refund Policy', href: ROUTES.REFUND_POLICY },
      ],
    },
    {
      title: 'For Photographers',
      links: [
        { name: 'Join as Photographer', href: ROUTES.REGISTER },
        { name: 'Browse Events', href: ROUTES.EVENTS },
      ],
    },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand section */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img
                src="/branding/logo_dark_compact.png"
                alt={APP_NAME}
                className="h-8"
              />
            </div>
            <p className="text-gray-300 mb-6">
              Professional photo sharing and sales platform connecting photographers with their
              clients.
            </p>

            {/* Contact info */}
            <div className="space-y-2 text-sm text-gray-300">
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <span>support@n3rd-media.com</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} />
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={16} />
                <span>San Francisco, CA</span>
              </div>
            </div>
          </div>

          {/* Footer sections */}
          {footerSections.map(section => (
            <div key={section.title}>
              <h3 className="text-lg font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map(link => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-gray-300 hover:text-primary-400 transition-colors text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="text-gray-400 text-sm">
              © {currentYear} {APP_NAME}. All rights reserved.
            </div>

            <div className="text-gray-400 text-sm mt-4 md:mt-0">
              <a href="mailto:support@n3rd-media.com" className="hover:text-primary-400 transition-colors">
                support@n3rd-media.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
